export enum IssueActivities {
  CommentAdded = 'commentAdded',
  Created = 'created',
  FieldUpdated = 'fieldUpdated',
  FieldRemoved = 'fieldRemoved',
  ManualFormCreated = 'manualFormCreated',
  AutomaticFormCreated = 'automaticFormCreated',
  ApprovalDeleted = 'approvalDeleted',
  ApprovalReset = 'approvalReset',
  ApprovalRejected = 'approvalRejected',
  ApprovalApproved = 'approvalApproved',
  ApprovalChangesRequested = 'approvalChangesRequested',
}

export enum InspectionActivities {
  Started = 'started',
  Submitted = 'submitted',
  Edited = 'edited',
  EditedSubmitted = 'editedSubmitted',
  Available = 'available',
  Overdue = 'overdue',
  ApprovalDeleted = 'approvalDeleted',
  ApprovalReset = 'approvalReset',
  ApprovalRejected = 'approvalRejected',
  ApprovalApproved = 'approvalApproved',
  ApprovalChangesRequested = 'approvalChangesRequested',
}

export enum ChecklistActivities {
  TemplateCreated = 'templateCreated',
  TemplateUpdated = 'templateUpdated',
  TemplateCreatedActive = 'templateCreatedActive',
  TemplateCreatedInactive = 'templateCreatedInactive',
  TemplateUpdatedActive = 'templateUpdatedActive',
  TemplateUpdatedInactive = 'templateUpdatedInactive',
}

export enum ActivityFields {
  reportedAt = 'reported_at'
}

export type EntityActivities = IssueActivities | InspectionActivities | ChecklistActivities;
